import React, { useContext, useState } from 'react'
import AddQuiz from '../components/Public/Quiz/AddQuiz';
import AllQuizzes from '../components/Public/Quiz/AllQuizzes'
import StateContext from '../StateContext';

function QuizPage() {

    const appState = useContext(StateContext);

    const [show, setShow] = useState(false);
    const [activeItem, setActiveItem] = useState("1");

    function toggle() {
        if (!show) {
            setShow(true);
        } else {
            setShow(false)
        }
    }

    function toggleTabs(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab);
        }
    }

    return (
        <div className="container my-3">
            {appState.loggedIn && (
                <div className="row">
                    <div className="col-6">
                        <button onClick={() => toggleTabs("1")} className="btn btn-block btn-primary">Quiz</button>
                    </div>
                    <div className="col-6">
                        <button onClick={() => toggleTabs("2")} className="btn btn-block btn-primary">Rediger</button>
                    </div>
                </div>
            )}

            <h2>Quiz Page</h2>
            
            {activeItem === "1" && (
                <React.Fragment>
                    <AllQuizzes />  
                </React.Fragment>
            )}
            

            {activeItem === "2" && (
                <React.Fragment>
                    <div className="text-center my-4">
                        <i onClick={toggle} className="fas fa-plus fa-2x"></i>
                    </div>
                    
                    {show && <AddQuiz />}
                </React.Fragment>

            )}
            
        </div>
    )
}
export default QuizPage